import { render } from "./collection-filter.vue?vue&type=template&id=347047da"
import script from "./collection-filter.vue?vue&type=script&lang=js"
export * from "./collection-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__